import shop1 from "../shops/shops-1.png";
import shop2 from "../shops/shops-2.png";
import shop3 from "../shops/shops-3.png";
import shop4 from "../shops/shops-4.png";
import shop5 from "../shops/shops-5.png";
import shop7 from "../shops/shops-7.png";
import shop8 from "../shops/shops-8.png";
import shop9 from "../shops/shops-9.png";
import shop10 from "../shops/shops-10.png";
import Hero1 from "../Hero/slide-1.png";
import Hero2 from "../Hero/slide-2.png";
import Hero3 from "../Hero/slide-3.png";
import Hero4 from "../Hero/slide-4.png";
import aside1 from "../Aside-cat/cat1.png";
import aside2 from "../Aside-cat/cat2.png";
import aside3 from "../Aside-cat/cat3.jpg";
import aside4 from "../Aside-cat/cat4.png";
import aside5 from "../Aside-cat/cat5.png";
import aside6 from "../Aside-cat/cat6.png";
import aside7 from "../Aside-cat/cat7.png";
import aside8 from "../Aside-cat/cat8.png";
import aside9 from "../Aside-cat/cat9.png";
import aside10 from "../Aside-cat/cat10.png";
import aside11 from "../Aside-cat/cat11.png";
import Flash1 from "../flash/flash-1.png";
import Flash2 from "../flash/flash-2.png";
import Flash3 from "../flash/flash-3.png";
import Flash4 from "../flash/flash-4.png";
import Flash5 from "../flash/flash-5.png";
import cat1 from "../category/category-1.png";
import cat2 from "../category/category-2.png";
import cat3 from "../category/category-3.png";
import arrival1 from "../arrivals/arrivals1.png";
import arrival2 from "../arrivals/arrivals2.png";
import arrival3 from "../arrivals/arrivals3.png";
import arrival4 from "../arrivals/arrivals4.png";
import arrival5 from "../arrivals/arrivals5.png";
import arrival6 from "../arrivals/arrivals6.png";
import discount1 from "../discount/discount-1.png";
import discount2 from "../discount/discount-2.png";
import discount3 from "../discount/discount-3.png";
import discount4 from "../discount/discount-4.png";
import discount5 from "../discount/discount-5.png";
import discount6 from "../discount/discount-6.png";
import discount7 from "../discount/discount-7.png";
import discount8 from "../discount/discount-8.png";
import discount9 from "../discount/discount-9.png";
import brand1 from "../category/cat-1.png";
import brand2 from "../category/cat-2.png";
export const Herodata = [
  {
    id: 1,
    title: "50% Off For Your First Shopping",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover: Hero1,
  },
  {
    id: 2,
    title: "50% Off For Your First Shopping",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover: Hero2,
  },
  {
    id: 3,
    title: "50% Off For Your First Shopping",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover: Hero3,
  },
  {
    id: 4,
    title: "50% Off For Your First Shopping",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover: Hero4,
  },
];

export const aside = [
  {
    id: 1,
    title: "Fashion",
    image: aside1,
  },
  {
    id: 2,
    title: "Electronic",
    image: aside2,
  },
  {
    id: 3,
    title: "Cars",
    image: aside3,
  },
  {
    id: 4,
    title: "Home & Garden",
    image: aside4,
  },
  {
    id: 5,
    title: "gifts",
    image: aside5,
  },
  {
    id: 6,
    title: "Music",
    image: aside6,
  },
  {
    id: 7,
    title: "Health & Beauty",
    image: aside7,
  },
  {
    id: 8,
    title: "Pets",
    image: aside8,
  },
  {
    id: 9,
    title: "Baby Toys",
    image: aside9,
  },
  {
    id: 10,
    title: "Groceries",
    image: aside10,
  },
  {
    id: 11,
    title: "Books",
    image: aside11,
  },
];

export const FlashDeals = [
  {
    id: 1,
    discount: 50,
    cover: Flash1,
    name: "Shoes",
    price: 100,
    quantity: 1,
  },
  {
    id: 2,
    discount: 40,
    cover: Flash2,
    name: "Watch",
    price: 20,
    quantity: 1,
  },
  {
    id: 3,
    discount: 40,
    cover: Flash3,
    name: "Smart Mobile Black",
    price: 200,
    quantity: 1,
  },
  {
    id: 4,
    discount: 40,
    cover: Flash4,
    name: "Smart Watch Black",
    price: 50,
    quantit: 1,
  },
  {
    id: 5,
    discount: 50,
    cover: Flash5,
    name: "Shoes",
    price: 100,
    quantity: 1,
  },
];

export const category = [
  {
    cover: cat1,
    para: "headphone",
    desc: "3k orders this week",
  },
  {
    cover: cat2,
    para: "watch",
    desc: "4k orders this week",
  },
  {
    cover: cat3,
    para: "sunglass",
    desc: "6k orders this week",
  },
  {
    cover: cat1,
    para: "watch",
    desc: "4k orders this week",
  },
  {
    cover: cat2,
    para: "sunglass",
    desc: "6k orders this week",
  },
];

export const shopItems = [
  {
    id: 7,
    cover: shop1,
    name: "Mapple Earphones",
    price: "180",
    discount: "25",
    quantity: 1,
  },
  {
    id: 8,
    cover: shop2,
    name: "Vivo android one",
    price: "120",
    discount: "10",
    quantity: 1,
  },
  {
    id: 9,
    cover: shop3,
    name: "Sony Light",
    price: "20",
    discount: "50 ",
    quantity: 1,
  },
  {
    id: 10,
    cover: shop4,
    name: "Iphone",
    price: "999",
    discount: "10 ",
    quantity: 1,
  },
  {
    id: 11,
    cover: shop5,
    name: "Ceats wireless earphone",
    price: "80",
    discount: "20 ",
    quantity: 1,
  },
  {
    id: 12,
    cover: shop7,
    name: "Redimi Phone",
    price: "400",
    discount: "20 ",
    quantity: 1,
  },
  {
    id: 13,
    cover: shop8,
    name: "Xeats Bluetooth earphones",
    price: "60",
    discount: "5 ",
    quantity: 1,
  },
  {
    id: 14,
    cover: shop9,
    name: "Airpod",
    price: "120",
    discount: "10",
    quantity: 1,
  },
  {
    id: 15,
    cover: shop10,
    name: "Silver Cap",
    price: "5",
    discount: "2",
    quantity: 1,
  },
];

export const arrivals = [
  {
    cover: arrival1,
    name: "Sunglass",
    price: "150",
  },
  {
    cover: arrival2,
    name: "Makeup",
    price: "250",
  },
  {
    cover: arrival3,
    name: "Smart Watch",
    price: "50",
  },
  {
    cover: arrival4,
    name: "Lipstick",
    price: "15",
  },
  {
    cover: arrival5,
    name: "Green Plant",
    price: "10",
  },
  {
    cover: arrival6,
    name: "Bonsai tree",
    price: "400",
  },
];

export const discont = [
  {
    cover: discount1,
    name: "BenuX 2022",
    price: "$250",
  },
  {
    cover: discount2,
    name: "Sony TV 1080p",
    price: "$450",
  },
  {
    cover: discount3,
    name: "Sony PS4",
    price: "$50",
  },
  {
    cover: discount4,
    name: "Setgearr 2022",
    price: "$100",
  },
  {
    cover: discount5,
    name: "Tony BGB",
    price: "$20",
  },
  {
    cover: discount6,
    name: "RG products",
    price: "$200",
  },
  {
    cover: discount7,
    name: "Ranasonic 2022",
    price: "$300",
  },
  {
    cover: discount8,
    name: "Pune HD",
    price: "$30",
  },
  {
    cover: discount9,
    name: "Sony CCTV",
    price: "$80",
  },
];
export const Brands = [
  {
    cover: brand1,
    name: "apple",
  },
  {
    cover: brand2,
    name: "samsung",
  },
  {
    cover: brand1,
    name: "oppo",
  },
  {
    cover: brand2,
    name: "vivo",
  },
  {
    cover: brand1,
    name: "redimi",
  },
  {
    cover: brand2,
    name: "sony",
  },
];
